import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { RocketLaunch, Telegram } from '@mui/icons-material';
import { accountTariffName } from './utils';
import { Chip } from '@mui/material';
import { AccountTariff } from 'console/billing/account-tariff/types';
export function TariffChip({ tariff, size, withLabel = true, }) {
    let color;
    switch (tariff) {
        case AccountTariff.free:
            break;
        case AccountTariff.zont_pro:
            color = 'primary';
            break;
    }
    let label;
    if (withLabel)
        label = accountTariffName(tariff);
    return (_jsx(Chip, { size: size, label: label, icon: _jsx(TariffIcon, { tariff: tariff }), color: color }));
}
export function TariffIcon(props) {
    const { tariff, ...rest } = props;
    switch (tariff) {
        case AccountTariff.free:
            return _jsx(Telegram, { ...rest });
        case AccountTariff.zont_pro:
            return _jsx(RocketLaunch, { ...rest });
        default:
            return null;
    }
}
